import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  productEditRequest,
  productResetState,
  productViewRequest,
} from "../../../redux/products/ProductAction";
import "../../../style/style.css";
import { StyledContainer, styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import {
  handleFileChange,
  convertImageToBase64,
} from "../../constant/commonFileUpload";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINK } from "../../global/MenuItems";
import { mapBackendMessage } from "../../notification/BackendMessage";
import CommonDialog from "../../notification/Dialogbox";
import CommonSnackbar from "../../notification/Snackbar";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import ImagePreviewDialog from "../../constant/commonImageDialog";
import { brandSearchViewAllRequest } from "../../../redux/brands/BrandAction";

const EditProduct = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    setError,
    reset,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [dialogMessage, setDialogMessage] = useState("");
  const [fileName, setFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [isImageOnlySave, setIsImageOnlySave] = useState(false);

  const productState = useSelector(
    (state) => state?.product?.viewProduct?.data || {}
  );
  const productList = productState || [];
  const editProductState = useSelector((state) => state?.product?.editProduct);

  const brandViewAllState = useSelector(
    (state) => state?.brand?.viewAllSearchBrands
  );

  const brandList = brandViewAllState?.data?.data || [];

  useEffect(() => {
    dispatch(brandSearchViewAllRequest());
  }, [dispatch]);

  const dynamicBrandOptions = brandList
    ?.filter((brand) => brand?.status !== 2)
    .map((brand) => ({
      value: brand?.id,
      label: brand?.brand_name,
    }));

  const inputFields = [
    {
      name: "product_code",
      label: "Sub Brand Code",
      readOnly: true,
    },
    {
      name: "brand_id",
      label: "Brand Name",
      type: "searchable-select",
      defaultValue: brandList[0]?.id,
      options: dynamicBrandOptions,
      size: "selectMedium",
    },
    {
      name: "product_name",
      label: "Sub Brand Name",
      // size: "medium",
    },
    {
      name: "description",
      label: "Description",
      size: "semiExtraLarge",
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "1", label: "Active" },
        { value: "2", label: "Inactive" },
      ],
      defaultValue: productList?.status,
    },
  ];

  const handleImageUpload = (event) => {
    handleFileChange(
      event,
      setSelectedFile,
      setImagePreview,
      setFileName,
      showSnackbar
    );
  };

  useEffect(() => {
    const existingImageUrl = "https://example.com/image.jpg";
    convertImageToBase64(existingImageUrl, (base64) => {
      setSelectedFile(base64);
    });
  }, []);

  const handleCancel = () => {
    dispatch(productResetState());
    navigate(APP_LINK.PRODUCTLIST);
  };

  useEffect(() => {
    if (id) {
      dispatch(productViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    reset();
    setSelectedFile(null);
    setImagePreview(uploadImage);

    if (productList && productList?.id === id) {
      setValue("product_code", productList?.product_code);
      setValue("brand_id", productList?.brand_id);
      setValue("product_name", productList?.product_name);
      setValue("description", productList?.description);
      setValue("status", productList?.status);

      const imageUrl = productList?.product_image;

      if (imageUrl) {
        if (imageUrl.startsWith("data:image")) {
          const base64Data = imageUrl.split(",")[1];
          setSelectedFile(base64Data);
          setImagePreview(imageUrl);
        } else {
          setImagePreview(imageUrl);

          convertImageToBase64(imageUrl).then((base64) => {
            if (base64) {
              setSelectedFile(base64);
            }
          });
        }
      } else {
        setSelectedFile(null);
        setImagePreview(uploadImage);
      }
    }
  }, [productList, id, setValue]);

  const onSubmit = (data) => {
    const normalizeText = (text) => text.replace(/\s+/g, " ").trim();
    let imageData = selectedFile;

    if (!selectedFile) {
      if (productList?.id === id && productList?.product_image) {
        imageData = productList.product_image;
      } else {
        showSnackbar(
          "Product Image is required. Please upload an image.",
          "error"
        );
        return;
      }
    }
    const editRequestData = {
      ...data,
      product_name: normalizeText(data?.product_name),
      description: normalizeText(data?.description),
      product_image: imageData,
      id,
    };
    dispatch(productEditRequest(id, editRequestData));
  };

  const handleImage = () => {
    if (selectedFile || productList?.product_image) {
      const imageData = selectedFile || productList?.product_image;

      const data = {
        product_code: productList?.product_code,
        brand_id: productList?.brand_id,
        product_name: productList?.product_name,
        description: productList?.description,
        status: productList?.status,
        product_image: imageData,
        id,
      };

      setIsImageOnlySave(true);
      dispatch(productEditRequest(id, data));
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const handleEditProductResponse = () => {
    if (editProductState?.success) {
      if (isImageOnlySave) {
        showSnackbar("Image saved successfully!", "success");
        dispatch(productViewRequest(id));
      } else {
        setDialogMessage("Sub Brand Updated Successfully!");
        setIsSuccess(true);
        setDialogOpen(true);
        navigate(APP_LINK.PRODUCTLIST);
      }

      dispatch(productResetState());
      // dispatch(productViewRequest(id));
      setIsImageOnlySave(false);
    } else if (editProductState?.error) {
      const errorMessage = editProductState?.errormessage;
      const errorFields = editProductState?.errorFields || {};

      if (Object.keys(errorFields).length > 0) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      } else if (typeof errorMessage === "string") {
        setError("product_name", {
          type: "manual",
          message: errorMessage,
        });
      } else {
        const customMessage = mapBackendMessage(
          editProductState?.errormessage ||
            "An error occurred while updating details."
        );
        setDialogMessage(customMessage);
        setIsSuccess(false);
        setDialogOpen(true);
      }
    }
  };

  useEffect(() => {
    handleEditProductResponse();
  }, [editProductState]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleImageClick = (image) => {
    if (image !== uploadImage) {
      setSelectedImage(image);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Update Sub Brand Details </h1>
              </Typography>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Sub Brand Image
              </Typography>
            </Box>
            <Box>
              <StyledContainer>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                    <img
                      src={imagePreview || uploadImage}
                      alt="Product"
                      width={80}
                      height={80}
                      style={styles.image}
                      onClick={() => handleImageClick(imagePreview)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Please upload square image, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          onChange={handleImageUpload}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(selectedFile)}
                        // disabled={!fileName}
                      >
                        {fileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={handleImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom sx={styles.note}>
                <span style={{ color: "red" }}>Note:</span> Only JPEG or PNG
                format is supported <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
          </Grid>
          {/* Form section */}
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
            />
            {/* Submit Button */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={editProductState?.inProgress}
                    loading={editProductState?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
      {/* Snackbar */}
      <CommonSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        redirectPath={APP_LINK.ADDPRODUCT}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />

      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
      />
    </Container>
  );
};
export default EditProduct;
